<template>
  <el-dialog :visible.sync="paVisible" :show-close="false" :close="back">
    <div class="container-sheet" v-loading="loading">
      <div class="back">
        <div class="tag" @click="back"><i class="el-icon-arrow-left"></i>Back</div>
        <div class="pirce">US${{Number(payAmount).toFixed(2)}}</div>
      </div>
      <!-- <div class="tips">* Thank you for order! Please contact our customer service to modify the discounted price for you.</div> -->
      <div class="tips">* We currently only support Visa, Mastercard, America Express</div>
      <div id="full-featured-card"></div>
      <!-- 这一部分单独提出公共部分 -->
      <payment-footer style="margin-top:20px"/>
    </div>
  </el-dialog>
</template>

<script>
import {Airwallex} from '@/api/123.js'
import paymentFooter from '../components/payment-footer.vue'
export default {
  components: { paymentFooter },
  props: {
    paVisible: {
      type: Boolean,
      default: false
    },
    intentOption: {
      type: Object,
      default: function() {
        return {}
      }
    },
    depositFlag: {
      type: Boolean,
      default: false
    },
    payAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      feNetWork: window.location.origin + '/',
      successUrl: '',
      failedUrl: ''
    }
  },
  created() {
    Airwallex.init({
      locale: 'en',
      env: (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') ? 'prod' : 'demo', // Which env('staging' | 'demo' | 'prod') you would like to integrate with
      origin: window.location.origin // Setup your event target to receive the browser events message
    })
    window.addEventListener('onReady', (event) => {
      console.log(JSON.stringify(event.detail))
    })
    let env = new Promise((resolve, reject) => {
      window.addEventListener('onSuccess', (event) => {
        if (event) {
          resolve(event)
        }
      })
    })
    env.then((event) => {
      this.$nextTick(() => {
        if (this.depositFlag) {
          let cardNumber = event.detail.intent.latest_payment_attempt.payment_method.card.bin + '••••' + event.detail.intent.latest_payment_attempt.payment_method.card.last4
          const params = {}
          params.cardNumber = cardNumber
          params.requestId = this.intentOption.intentId
          params.result = 'success'
          this.$emit('payResult', params)
        } else {
          this.$router.push({path: '/pay-result', query: {orderId: this.intentOption.orderId, status: 1, times: (new Date().getTime() - this.intentOption.startDate.getTime())}})
        }
      })
    })
    let errorEnv = new Promise((resolve, reject) => {
      window.addEventListener('onError', (event) => {
        if (event) {
          resolve(event)
        }
      })
    })
    errorEnv.then((event) => {
      // add by cpgu 2022/06/17 begin
      // PA自定义错误码（他们封装的拦截）
      // let pa = event.detail.error.code ;
      // 发卡行返回的错误吗（通过PA的后，才会显示此错误码）
      let bankOriCode = (event.detail && event.detail.error && event.detail.error.original_code) ? event.detail.error.original_code : '-1'
      // end by cpgu

      this.$nextTick(() => {
        if (this.depositFlag) {
          const params = {}
          params.cardNumber = ''
          params.result = 'failed'
          params.requestId = this.intentOption.intentId
          this.$emit('payResult', params)
        } else {
          this.$router.push({path: '/pay-result',
            query:
                {
                  orderId: this.intentOption.orderId,
                  status: 11,
                  errorCode: bankOriCode,
                  times: (new Date().getTime() - this.intentOption.startDate.getTime())
                }})
        }
      })
    })
  },
  watch: {
    intentOption(n, o) {
      if (n !== o) {
        this.loading = true
        setTimeout(() => {
          if (this.depositFlag) {
            const element = Airwallex.createElement('fullFeaturedCard', {
              intent: {
                id: this.intentOption.intentId,
                client_secret: this.intentOption.clientSecret
              },
              autoCapture: false
            })
            element.mount('full-featured-card')
          } else {
            const element = Airwallex.createElement('fullFeaturedCard', {
              intent: {
                id: this.intentOption.intentId,
                client_secret: this.intentOption.clientSecret
              }
            })
            element.mount('full-featured-card')
          }
          this.loading = false
        }, 2000)
      }
    },
    depositFlag(n, o) {
      if (n !== o) {
        this.depositFlag = n
      }
    },
    paVisible(n, o) {
      if (n !== o) {
        this.paVisible = n
      }
    },
    deep: true
  },
  destroyed() {
    window.removeEventListener('onSuccess')
    window.removeEventListener('onError')
    window.removeEventListener('onReady')
  },
  methods: {
    back() {
      this.$emit('backPaVisible', 'paVisible')
    }
  }
}
</script>
<style lang="less" scoped>
.el-dialog__wrapper{z-index: 1400 !important;}
.el-divider--horizontal{
  margin:5px 0
}

.el-divider--horizontal{
  margin:5px 0
}
.bank-content{margin-top: 20px;font-size: 14px;
font-family: Graphik;
font-weight: 500;
color: #262B2F;
opacity: 1;}
.inp-number{font-size: 14px;font-family: Graphik;font-weight: 500;color: #262B2F;opacity: 1;}
.container-sheet{
  padding: 30px;
  background: #FFFFFF;
  border: 1px solid #E1E1E1;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 5px;
  .tips{
    margin-top: 10px;
    color:#F77073;
    font-family: Graphik;
    font-size: 14px;
  }
  .back{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #262B2F;
    font-size: 20px;
    font-weight: 800;
    color: #000000;
    .tag{
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #262B2F;
    }
  }
  .container-logo{
    display: flex;
    justify-content: center;
    margin-top: 20px;
    img{
        width: 130px;
        height: 60px;
    }
  }
  .logo-left{
    display: flex;
    justify-content: start;
  }
  .title-wrap{
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    font-size: 16px;
    font-weight: 500;
    color: #262B2F;
  }
  .inp-wrap{
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
    padding: 20px;
    margin-top: 30px;
    .inp-title{
      font-size: 14px;
      font-weight: 500;
      color: #262B2F;
    }
    .inp-list{
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      .inp-item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          .inp-name{
              display: flex;
              width: 120px;
              color: #707070;
              font-size: 14px;
          }
          .inp-input{
              display: flex;
              flex:1;
              color: #262B2F;
          }
      }
    }
  }
  .bank-wrap{
    display: flex;
    flex-direction: column;
    padding: 20px 0;
    .bank-title{
      font-size: 14px;
      font-weight: 500;
      color: #262B2F;
      opacity: 1;
    }
    .bank-list{
      display: flex;
      border-bottom: 1px solid #E1E1E1;
      .bank-item{
          display: flex;
          flex-direction: column;
          flex:1;
          padding: 10px 0;
      }
    }
  }
  .note{
    display: flex;
    flex-direction: column;
  }
  .btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 25px 0;
    .btn{
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      height: 50px;
      color: #FFFFFF;
      background: #262B2F;
      font-size: 14px;
      font-weight: 500;
      border-radius: 4px;
    }
  }
  .notice{
    display: flex;
    align-items: center;
    border-radius: 4px;
    font-size: 14px;
    margin-top: 20px;
    padding:20px;
    .notice-pic{
        font-size: 20px;
        margin-right: 10px;
    }
  }
  .notice-warning{
    background: #D2E8C7;
  }
}
@media screen and(max-width: 600px) {
  /deep/ .el-dialog{width: 100% !important}
}
</style>



// WEBPACK FOOTER //
// src/pages/checkout/pa-pay.vue